<template>
  <div class="order-history">
    <table>
      <thead>
        <tr>
          <th>{{ $t(`DATE`) }}</th>
          <th>{{ $t(`ITEM`) }}</th>
          <th>{{ $t(`TOTAL`) }}</th>
          <th>{{ $t(`STATUS`) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in orders" :key="order.id">
          <td>{{ formatDate(order.created_at) }}</td>
          <td class="item-cell">
            <img
              :src="imgDomain + order.img_url"
              :alt="order.title"
              class="item-image"
            />
            <div class="item-details">
              <span class="item-type">{{ order.item_type }}</span>
              <span class="item-title" :title="order?.title">{{
                order.title || "No title"
              }}</span>
            </div>
          </td>
          <td class="price-cell">
            {{ formatCurrency(order.sum, order?.currency) }}
          </td>
          <td>
            <span
              class="status-badge"
              :class="`status-badge--${order.status
                .toLowerCase()
                .replace(/ /g, '-')}`"
            >
              {{ order.status }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="error" class="error-message">
      {{ $t("Failed to fetch orders.") }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "orderHistory",
  data() {
    return {
      imgDomain: "",
      orders: [],
      error: false,
    };
  },
  methods: {
    formatDate(timestamp) {
      return moment.unix(timestamp).format("DD.MM.YYYY HH:mm");
    },
    formatCurrency(amount, currency) {
      return `${currency} ${parseFloat(amount).toFixed(2)}`;
    },
    fetchorderHistory() {
      this.$http
        .get(`${process.env.VUE_APP_API}purchase/history`)
        .then((res) => {
          this.orders = res.data.payload.filter(
            (item) => item.status == "offer",
          );
          this.error = false;
        })
        .catch((error) => {
          this.error = true;
          if (error.response && error.response.status === 401) {
            this.$emit("open-sign-in");
          }
        });
    },
  },
  created() {
    this.fetchorderHistory();
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
};
</script>

<style scoped>
.order-history {
  overflow-x: auto;
  margin-top: 16px;
  background: #191919;
  padding: 32px;
  border-radius: 12px;
}

table {
  margin-top: 32px;
  width: 100%;
  border-collapse: collapse;
  display: grid;
  /* Enable grid layout */
  grid-template-columns: 1.5fr 4fr 2fr 1fr;
  /* Define column widths using fr units */
}

thead,
tbody,
tr {
  display: contents;
  /* Make table rows and cells grid items */
}

th,
td {
  padding: 16px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
}

th {
  color: #fff;
  padding: 20px;
  background: #2b2b2b;
}
th:first-child {
  border-radius: 12px 0 0 12px;
}

th:last-child {
  border-radius: 0 12px 12px 0;
}
td {
  font-weight: 400;
  color: #fff;
  padding: 13px 20px 13px;
}

/* Special padding for the first row */
tbody tr:first-of-type td {
  padding-top: 20px;
}

.status-badge {
  width: 100%;
  display: inline-block;
  padding: 7px 12px;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  /* Center text within badge */
  text-transform: uppercase;
}

.status-badge.success {
  color: #27d639;
}

.status-badge.pending {
  color: #ffbf00;
}

.status-badge.error {
  color: #ff0000;
}

.error-message {
  color: red;
  margin-top: 10px;
  text-align: center;
}

.item-cell {
  display: flex;
  align-items: center;
}

.item-image {
  height: 60px;
  margin-right: 28px;
  object-fit: cover;
}

.item-details {
  display: flex;
  flex-direction: column;
}

.item-type {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #b7b8c1;
  margin-bottom: 2px;
}

.item-title {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  max-width: 350px;
  white-space: nowrap;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price-cell {
  text-wrap: nowrap;
}
</style>
